import { useQuery } from '@tanstack/react-query';

import { queries } from '../../common/api/queryKeys/queries';
import { useRole } from '../../common/hooks/useRole';

export const useFee = (offerId) => {
    const role = useRole();

    return useQuery({
        ...queries.offers.detail(offerId)._ctx.fees,
        enabled: role.isSupplier() || role.isSuperAdmin(),
    });
};
